// extracted by mini-css-extract-plugin
export var defaultWrapper = "_ls-3";
export var downloadButton = "_ls-4";
export var fileContainer = "_ls-9 _ls-7";
export var fileContainerBase = "_ls-7";
export var fileContainerFixedHeight = "_ls-8 _ls-7";
export var fileInfo = "_ls-5";
export var fileInfoWidthRestricted = "_ls-6";
export var fileType = "_ls-1";
export var fileTypeName = "_ls-2";
export var image = "_ls-0";
export var link = "_ls-b";
export var overflowEllipsis = "_ls-a";